import { createContext, useContext } from "react"
import { MainBorrowerProfilingAction, MainBorrowerProfilingAsyncActions, MainBorrowerProfilingState, MainBorrowerProfilingSyncActions } from "./actions"

const contextErrorMessage = 'useMainBorrowerProfiling must be used within a MainBorrowerProfilingProvider'

export interface MainBorrowerProfilingContextProps extends MainBorrowerProfilingAsyncActions, MainBorrowerProfilingSyncActions {
  state: MainBorrowerProfilingState
  dispatch: React.Dispatch<MainBorrowerProfilingAction>
}

export const MainBorrowerProfilingContext = createContext<MainBorrowerProfilingContextProps | undefined>(undefined)

export const useMainBorrowerProfiling = () => {
  const context = useContext(MainBorrowerProfilingContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }
  return context
}

export const useMainBorrowerProfilingActions = () => {
  const context = useContext(MainBorrowerProfilingContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }

  const {
    state,
    dispatch,
    ...actions
  } = context

  return actions
}

export const useMainBorrowerProfilingState = () => {
  const context = useContext(MainBorrowerProfilingContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }

  return context.state
}
